import { Granularity } from "@hydrologiq/common/types/reporting/Granularity"
import { formatYYYYMMDD } from "@hydrologiq/common/helpers/date"
import { DateTime } from "timezonecomplete"
import { toKey } from "@hydrologiq/common/test/toKey"
import { downloadBlob } from "./downloadBlob"

interface DownloadProps {
  start: DateTime
  end: DateTime
  granularity: Granularity
  data: string
  baseName: string
  callback?: () => void
}

function Download({ start, end, granularity, data, baseName, callback }: DownloadProps) {
  const download = async () => {
    downloadBlob(
      data,
      `${toKey(baseName)}_${granularity}_${formatYYYYMMDD(start)}_${formatYYYYMMDD(end)}.csv`,
      "text/csv;charset=utf-8;"
    )
    if (callback) callback()
  }
  download()

  return <></>
}

export default Download
